// Haptic Feedback wrapper for iOS PWA (Vibration API)
// iOS Safari requires a user gesture before vibrate() works, but we
// guard with `try/catch` so SSR / unsupported browsers fail silently.

type Pattern = "light" | "medium" | "heavy" | "success" | "warning" | "error";

const patterns: Record<Pattern, number | number[]> = {
  light: 8,
  medium: 15,
  heavy: 25,
  success: [10, 30, 10],
  warning: [20, 40, 20],
  error: [50],
};

export function haptic(p: Pattern): void {
  try {
    if (typeof navigator === "undefined" || !navigator.vibrate) return;
    navigator.vibrate(patterns[p]);
  } catch {
    // ignore — unsupported / blocked
  }
}
